import style from './benefits-of-dedicated-teams.module.scss';
import template from '@components/services/services.module.scss';
import Image from 'next/image';
import { IDedicatedTeamListItem } from '@components/services/dedicated-teams/dedicated-teams.state';

interface IBenefitsOfDedicatedTeamsProps {
  title: string;
  description: string;
  items: IDedicatedTeamListItem[];
}

const BenefitsOfDedicatedTeamsSection = ({ title, description, items }: IBenefitsOfDedicatedTeamsProps) => {
  return (
    <section className={`${template.section} ${template.section_light} ${style.section}`}>
      <div className={`${template.container} ${style.benefits__header}`}>
        <div
          className={`${template.title} ${template.title_large} ${template.mb20} ${template.text_align_c} ${style.benefits__title}`}
        >
          <h2 className={`${template.title_large}`}>{title}</h2>
        </div>
        <div
          className={`${template.mb40} ${template.text} ${template.text_color_main} ${template.text_small} ${template.text_align_c} ${template.fw400}  ${style.benefits__header__text}`}
        >
          {description}
        </div>
      </div>
      <div className={`${template.container} ${template.container_large}`}>
        <div className={`${style.benefits__items}`}>
          {items.map((item: IDedicatedTeamListItem, index: number) => {
            return (
              <div className={`${style.benefits__item}`} key={index}>
                <div className={`${style.benefits__item__image} ${template.mr20}`}>
                  <Image src={item.iconSrc} alt={item.title} layout="fill" objectFit="contain" />
                </div>
                <div
                  className={`${template.text} ${template.text_small} ${template.text_color_main} ${style.benefits__item__header}`}
                >
                  {item.title}
                </div>
                <div
                  className={`${style.benefits__item__text} ${template.text} ${template.text_small} ${template.text_align_l} ${template.text_color_main} ${template.fw400}`}
                >
                  {item.text}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BenefitsOfDedicatedTeamsSection;
